import React, { useEffect, useState } from "react";
import BasePage from "../../../Components/Base/BasePage";
import CardSimpleComponent from "../../../Components/Forms/CardSimpleComponent";
import CardProgressBarComponent from "../../../Components/Forms/CardProgressBarComponent";
import axios from "axios";
import { Button } from "@mui/material";
import { ReactSortable } from "react-sortablejs";
import EventoLogisticoDetalheViagemPopup from "./EventoLogisticoDetalheViagemPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGears, faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";

let timerPainelLogistico: NodeJS.Timeout;

const EventoLogisticoPage = (props: any) => {
    const [ordemCards, setOrdemCards] = useState<any[]>([]);
    const [usuario, setUsuario] = useState<any>([]);
    const [resumos, setResumos] = useState<any>([]);
    const [detalhes, setDetalhes] = useState<any>();
    const [cardSelecionado, setCardSelecionado] = useState<string>(''); 
    const [isOpenDetalhe, setIsOpenDetalhe] = useState(false);
    const [viagemId, setViagemId] = useState('');
    const [enableDrag, setEnableDrag] = useState(false);
    const [loading, setLoading] = useState(false);

    const descricoes: any = {
        'programacoes': 'Programações',
        'atraso_checklist': 'Atraso checklist',
        'em_patio': 'Em pátio',
        'em_transito_origem': 'Em trânsito origem',
        'patio_nao_iniciado': 'Pátio não iniciado',
        'atraso_chegada': 'Atraso chegada',
        'atrasada': 'Atrasada',
        'tendencia_de_atraso': 'Tendência de atraso',
        'em_descarga': 'Em descarga',
        'atraso_inicio_previsto': 'Atraso início previsto',
        'atraso_fim_previsto': 'Atraso fim previsto',
        'aguardando_inicio_viagem': 'Aguardando início viagem',
        'em_viagem': 'Em viagem',
        'sem_previsao_carregamento': 'Sem previsão carregamento',
        'com_previsao_carregamento': 'Com previsão carregamento',
        'em_processo_pa': 'Em processo PA',
        'em_bolsao': 'Em bolsão',
        'atraso_patio': 'Atraso pátio',
        'atraso_carregamento': 'Atraso carregamento',
        'em_checklist': 'Em checklist',
        'em_carregamento': 'Em carregamento',
        'veiculos_sem_viagem': 'Veículos sem viagem',
        'viagem_deslocamento': 'Viagem deslocamento',
    };

    useEffect(() => {(async () => inicializaAsync())()}, []);
    useEffect(carregaDadosCard, [usuario]);

    async function inicializaAsync() {
        setLoading(true);
        await carregaUsuarios();
        await carregaDados();
        localRecursiveEvent('');
        setLoading(false);
    }

    function dadosCardPadrao() {
        let ordem:any = [];
        for (let index = 0; index < Object.keys(descricoes).length; index++) {
            ordem.push([index, 1]);
        }

        return ordem;
    }

    function carregaDadosCard() {
        let ordem:any = [];
        //console.log(usuario.ordem_card_painel_eventos_logisticos);
        if (usuario.ordem_card_painel_eventos_logisticos == null || usuario.ordem_card_painel_eventos_logisticos == '') {
            ordem = dadosCardPadrao();
        }
        else {
            try {
                ordem = JSON.parse(usuario.ordem_card_painel_eventos_logisticos);
            } catch (error) {
                ordem = dadosCardPadrao();
            }
        }

        setOrdemCards(ordem);
    }

    async function carregaDados(card = '') {
        if (enableDrag) {
            return;
        }

        await carregaResumos();
        await carregaDetalhes(card);
    }

    async function carregaUsuarios() {
        let response = await axios.get('usuario');
        setUsuario(response.data);
    }

    async function carregaResumos() {        
        let resumos = await getResumos();
        setResumos(resumos);
    }
    
    async function carregaDetalhes(card = '') {
        let detalhes = await getDetalhes(card);
        setDetalhes(detalhes);
    }

    const getResumos = async () => {
        document.body.style.cursor = "progress";

        let response = await axios.get('painelEventoLogisticoResumos');
        const entries = Object.entries(response.data[0]);
        let dataResponse: any = [];
        entries.forEach(([key, value]) => {
            dataResponse.push({descricao:descricoes[key]??key, key:key, value:value});
        });

        document.body.style.cursor = "default";
        return dataResponse;
    };
    
    const getDetalhes = async (key: string = '') => {
        document.body.style.cursor = "progress";
        let parametros: string = '';
        if (key != "") {
            parametros = `?cards=${key}`;
        }

        let response = await axios.get(`painelEventoLogisticoDetalhes${parametros}`);
        
        document.body.style.cursor = "default";
        return response.data;
    };

    async function selecionaCardPrincipalCarregaResumos(key: string) {
        try {
            setLoading(true);
            if (key == cardSelecionado) {
                key = '';
            }

            if (enableDrag) {
                setCardSelecionado(key);
                return;
            }

            clearTimeout(timerPainelLogistico);
            let detalhes = await getDetalhes(key);
            setCardSelecionado(key);
            setDetalhes(detalhes);
            localRecursiveEvent(key);
        }
        finally {
            setLoading(false);
        }
    }
    
    function closePopupDetalhe() {
        console.log('fe');
        setIsOpenDetalhe(false);
    }

    function openViagemDetalhe(viagem_id:any) {
        if (viagem_id == null) {
            return;
        }

        setViagemId(viagem_id);
        setIsOpenDetalhe(true);
    }

    function localRecursiveEvent(card='') {
        clearTimeout(timerPainelLogistico);
        if (enableDrag) {
            setTimeout(() => { localRecursiveEvent(card); }, 20000)
            return;
        }

        try {
            timerPainelLogistico = setTimeout(() => { carregaDados(card);localRecursiveEvent(card); }, 60000);
        } catch (ex) {
            timerPainelLogistico = setTimeout(() => { carregaDados(card);localRecursiveEvent(card); }, 20000);
        }
    }

    async function editar() {
        setEnableDrag(!enableDrag);
        if (!enableDrag) {
            return;
        }

        for (let index = 0; index < ordemCards.length; index++) {
            ordemCards[index][1] = ordemCards[index][1] || ordemCards[index][1] == 1 ? 1 : 0;
            delete ordemCards[index].chosen;
            delete ordemCards[index].selected;
            delete ordemCards[index].quantidade;
        }

        await axios.put('usuario/ordemCardPainelEventosLogisticos', {
            'ordem_card_painel_eventos_logisticos':ordemCards
        });

        console.log(JSON.stringify(ordemCards));
    }

    function setCardVisivel(key:string, value:any) {
        ordemCards.filter((x:any) => Object.keys(descricoes)[x[0]] == key)[0][1] = !value;
    }

    const FixedItems = () => {
        return (
            <div className="card-group">
            {
                ordemCards.map((ordemCard: any) =>
                    (
                        resumos.map(function (resumo: any)
                        {
                            let keyCardAtual = Object.keys(descricoes)[ordemCard[0]];
                            let tituloCard = Object.values(descricoes)[ordemCard[0]];

                            if (keyCardAtual != resumo.key) {
                                return;
                            }

                            ordemCard.quantidade = resumo.value ?? 0;

                            return <CardSimpleComponent 
                                index={ordemCard[0]}
                                key={ordemCard[0]}
                                title={tituloCard}
                                cardAtual={keyCardAtual}
                                quantity={ordemCard.quantidade}
                                visible={ordemCard[1]}
                                cardSelecionado={cardSelecionado}
                                onClick={() => selecionaCardPrincipalCarregaResumos(keyCardAtual)} />
                        })
                    )
                )
            }
            </div>
        );
    };

    return (
        <BasePage loading={loading}>
            <main style={{marginLeft:-10, textAlign:'start'}}>
                <section className="mb-2">
                    {!enableDrag ? 
                        <FixedItems /> :
                        <ReactSortable list={ordemCards} setList={setOrdemCards} className="card-group">
                        {
                            ordemCards.map((e:any) => (
                                <CardSimpleComponent 
                                    enableDrag={true}
                                    key={e[0]}
                                    title={Object.values(descricoes)[e[0]]}
                                    cardAtual={Object.keys(descricoes)[e[0]]}
                                    visible={true}
                                    quantity={e.quantidade}
                                    visibleCheckbox={e[1]}
                                    changeVisibleCheckbox={setCardVisivel}
                                    cardSelecionado={false} />
                            ))
                        }
                        </ReactSortable>
                    }

                    <Button style={{fontSize: '8pt'}} onClick={editar}>{enableDrag ? <FontAwesomeIcon icon={faCloudArrowUp} title="Salvar" /> : <FontAwesomeIcon icon={faGears} title="Editar" />}</Button>
                </section>

                {enableDrag ? '' : 
                    <section className="card-group">
                        {detalhes?.map((e: any) => (
                            <CardProgressBarComponent 
                                status={e.status_viagem}
                                porcentagem={e.distancia_porcentagem_percorrida??0} 
                                placa={e.placa} 
                                tempo={e.tempo}
                                doca={e.doca_origem}
                                onClick={() => openViagemDetalhe(e.viagem_id)}
                            />
                        ))}
                    </section>
                }
            </main>

            {isOpenDetalhe ? <EventoLogisticoDetalheViagemPopup isOpen={isOpenDetalhe} onClose={closePopupDetalhe} viagem_id={viagemId} /> : ''}
        </BasePage>
    );
}

export default EventoLogisticoPage;